import UserDrawerContent from "./UserDrawerContent";

export default UserDrawerContent;
